export default __webpack_public_path__ + "static/media/blessingit.c88fdd23.mp3";